import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export type Initializer = Observable<unknown>;

export const INITIALIZER = new InjectionToken<Initializer>('INITIALIZER');
